import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';

import {
  Environment,
  IsError,
  IPushNotification,
  NotificheTokenPersone,
  ModelStr,
  ModelNumSearch,
  ModelNum,
  FCMTokenRemoveModel,
} from '../../models/-index';

@Injectable()
export class NotificheTokenPersoneService extends CrudGenericsService<NotificheTokenPersone, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/NotificheTokenPersone`);
    this.base = `${env.apiUrl}/api/NotificheTokenPersone/`;
  }

  /*
  RemoveToken(_token: string) {
    const token: ModelStr = { Value: _token };
    const url = this.base + 'RemoveToken';
    return this.http.post(`${url}`, token);
  }*/
  SendNotificationWeb_ToAllRegistered(model: IPushNotification): Observable<IsError> {
    const url = this.base + 'SendNotificationWeb_ToAllRegistered';
    return this.http.post<IsError>(`${url}`, model);
  }
  SendNotificationWeb_ToPersona(id: number, model: IPushNotification): Observable<IsError> {
    const url = this.base + 'SendNotificationWeb_ToPersona?id=' + id;
    return this.http.post<IsError>(`${url}`, model);
  }
  SendNotificationWeb_ToPersoneGruppo(id: number, model: IPushNotification): Observable<IsError> {
    const url = this.base + 'SendNotificationWeb_ToPersoneGruppo?id=' + id;
    return this.http.post<IsError>(`${url}`, model);
  }
  // ionic on logout
  FCMRemoveToken_OnLogoutOrHostChange(model: FCMTokenRemoveModel): Observable<IsError> {
    const url = this.base + 'FCMRemoveToken_OnLogoutOrHostChange';
    return this.http.post<IsError>(`${url}`, model);
  }
  // ionic
  FCMToken_CheckAndSeverSync(model: NotificheTokenPersone): Observable<IsError> {
    const url = this.base + 'FCMToken_CheckAndSeverSync';
    return this.http.post<IsError>(`${url}`, model);
  }
  // ReSendNotifiche_NotOnlinee

  ReSendNotifiche_NotOnline(persona: number): Observable<IsError> {
    const model: ModelNum = { Value: persona };
    const url = this.base + 'ReSendNotifiche_NotOnline';
    return this.http.post<IsError>(`${url}`, model);
  }
}
